import http from "../ http-common";
import store  from "../store";

const getApibaseurl = () => {
  const state = store.getState();
  console.log("kjhgfdsadfgh uytfyguyi ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};

class DocumentTypeService {
  getAll(page, limit, filter) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/document_types`, {
      params: {
        page,
        limit,
        ...filter,
      },
    });
  }

  get(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/document_types/${id}`);
  }

  create(form) {
    var formData = new FormData();
    for (const [key, value] of Object.entries(form)) {
      formData.append(`${key}`, `${value}`);
    }
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.post(`${API_BASE_URL}/document_types`, formData);
  }

  update(id, form) {
    // send action
    var formData = new FormData();
    for (const [key, value] of Object.entries(form)) {
      formData.append(`${key}`, `${value}`);
    }
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.post(`${API_BASE_URL}/document_types/update`, formData);
  }

  delete(id) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/document_types/${id}`);
  }

  deleteAll() {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.delete(`${API_BASE_URL}/document_types`);
  }

  toggleStatus(id, attribute) {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/document_types/toggle_status/${id}/${attribute}`);
  }
}

export default new DocumentTypeService();
